import * as React from 'react';
//import { AppProps } from '../../components/app';
import PackageListingContainer from '../../components/package-listing-container';
import CartContainer from '../../components/cart/container';
import QuantitySelect from '../../components/cart/quantity-select';

import FiltersContainer from '../../components/filters/container';
import { AppProps } from '../../components/app';

// Resize Sensor will ensure the sticky sidebar is able to update itself when the content changes
import 'css-element-queries/src/ResizeSensor.js';
import { StickySidebarComponent } from '../../../../Static/javascript/Ace2/modules/sticky-sidebar-component';

interface FlexState {
    stickyInstance: any;
}

class AppView extends React.Component<AppProps, FlexState> {
    constructor(props) {
        super(props);

        this.state = {
            stickyInstance: null
        }
    }

    componentDidMount() {
        this.stickyCart();
    }

    stickyCart() {
        if (this.state) {
            if (this.state.stickyInstance == null) {
                const fixedSubsSticky = new StickySidebarComponent(document.getElementById('fixedSubsMiniCart'));
                this.setState({
                    stickyInstance: fixedSubsSticky.stickySidebar
                });
                // Needs to update after render is done
                window.requestAnimationFrame(() => {
                    this.state.stickyInstance.updateSticky();
                });
            }
            else {
                this.state.stickyInstance.updateSticky();
            }
        }
    }
    render() {
        return (
            <>
                {this.props.minimumPackagePerformanceQuantityMessage ?
                    <p className="ace-subs-intro">
                        {this.props.minimumPackagePerformanceQuantityMessage}</p>
                    : null
                }

                <nav className="ace-filters-container space-top-xl stack-sm">
                    <h2 className="ace-subs-filter-heading h3-style">{this.props.text.filtersTitle}</h2>
                    <FiltersContainer />
                </nav>
                <div className="ace-layout ace-layout-8-4">
                    <div>
                        <PackageListingContainer />
                    </div>
                    <div data-sticky-container>
                        <div className="ace-minicart ace-minicart-borderless" id="fixedSubsMiniCart" data-sticky-el data-margin-top="0" data-sticky-for="1024" data-sticky-class="stuck">
                            <div className="ace-minicart-inner ace-minicart-review" id="review" data-sticky-inner>
                                <CartContainer updateStickyCart={this.stickyCart.bind(this)} />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default AppView;